module.exports = __webpack_public_path__ + "static/media/ic-callkit-audio-on.835c6cfb.webp";